import styled from "styled-components";
import {BurgerIconDefaultBox} from "./burger-icon.default.box";

export const BurgerIconCasino777Box = styled(BurgerIconDefaultBox)`
  width: 30px;
  height: 20px;
  background-position: -555px -524px;
`